import { BodyText, Button, Input } from "@/components/ui";
import { useState } from "react";
import { ResourceTypeSelect } from "./ResourceTypeSelect";

interface DirectLookupProps {
  initialType?: string;
  initialId?: string;
  onInspect: (resourceType: string, resourceId: string) => void;
}

/** Look up a single FHIR resource by type + id (engineering-oriented entry). */
export const DirectLookup = ({
  initialType,
  initialId,
  onInspect,
}: DirectLookupProps) => {
  const [resourceType, setResourceType] = useState(initialType ?? "");
  const [resourceId, setResourceId] = useState(initialId ?? "");

  const canSubmit = Boolean(resourceType && resourceId.trim());

  return (
    <form
      className="flex flex-col gap-3 max-w-md"
      onSubmit={(event) => {
        event.preventDefault();
        if (canSubmit) onInspect(resourceType, resourceId.trim());
      }}
    >
      <div className="space-y-1">
        <BodyText size="sm" textColor="secondary">
          Resource type
        </BodyText>
        <ResourceTypeSelect value={resourceType} onChange={setResourceType} />
      </div>
      <div className="space-y-1">
        <BodyText size="sm" textColor="secondary">
          Resource id
        </BodyText>
        <Input
          value={resourceId}
          onChange={(event) => setResourceId(event.target.value)}
          placeholder="e.g. 0192abcd-…"
        />
      </div>
      <Button type="submit" disabled={!canSubmit} className="w-fit">
        Inspect
      </Button>
    </form>
  );
};
